import { ParagraphPlaceholder, ParagraphPlaceholderProps } from 'src/components/paragraph-placeholder';
import { defaultParagraphPlaceholderStyles } from 'src/components/paragraph-placeholder/default-paragraph-placeholder-styles';
import { withUpdatedTheme } from 'src/components/theme';

export const StyledContentPlaceholder = withUpdatedTheme<ParagraphPlaceholderProps>({
  paragraphPlaceholder: {
    ...defaultParagraphPlaceholderStyles,
    container: {
      ...defaultParagraphPlaceholderStyles.container,
      marginBottom: '237px',
    },
    paragraph: {
      ...defaultParagraphPlaceholderStyles.paragraph,
      width: '372px',
    },
  },
})(ParagraphPlaceholder);
